export enum ThirdPartyTrackerId {
  REGISTRATION_FINISHED = 1,
}
